import type { LawFirmCustomer, PagedList } from '~/models'
import { $apiDelete, $apiGet, $apiPost, $apiPut } from '~/utils/request'

export const Get = params => $apiGet<PagedList<LawFirmCustomer>>(`/v1/lawFirmCustomer`, params)

// export const GetByNameAndType = (params, isLoading?) => $apiGet<LawFirmCustomer[]>(`/v1/lawFirmCustomer/byNameAndType`, params, isLoading)

// export const GetByIdentityNumberAndType = (params, isLoading?) => $apiGet<LawFirmCustomer[]>(`/v1/lawFirmCustomer/byIdentityNumberAndType`, params, isLoading)

// export const GetByTaxIDAndType = (params, isLoading?) => $apiGet<LawFirmCustomer[]>(`/v1/lawFirmCustomer/byTaxIDAndType`, params, isLoading)

export const GetByNameKeyword = (params, isLoading?) => $apiGet<LawFirmCustomer[]>(`/v1/lawFirmCustomer/byNameKeyword`, params, isLoading)

export const GetByName = params => $apiGet<LawFirmCustomer[]>(`/v1/lawFirmCustomer/byName`, params)

export const GetByEncryptionId = encryptionId => $apiGet<LawFirmCustomer>(`/v1/lawFirmCustomer/${encryptionId}`)

export const Post = body => $apiPost<void>(`/v1/lawFirmCustomer`, body)

export const Put = (encryptionId, body) => $apiPut<void>(`/v1/lawFirmCustomer/${encryptionId}`, body)

export const Remove = encryptionId => $apiPut<void>(`/v1/lawFirmCustomer/remove/${encryptionId}`)

// export const Delete = encryptionId => $apiDelete<void>(`/v1/lawFirmCustomer/${encryptionId}`)
